import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const sections = [
  {
    title: 'Subsystems',
    links: [
      { to: '/subsystems/rerr',  label: 'RERR — Event Reporting' },
      { to: '/subsystems/ifps',  label: 'IFPS — Identity Fraud' },
      { to: '/subsystems/firl',  label: 'FIRL — Funds Integrity' },
      { to: '/subsystems/veris', label: 'VERIS — Voter Registration' },
      { to: '/subsystems',       label: 'View all' },
    ],
  },
  {
    title: 'Who we serve',
    links: [
      { to: '/for-citizens',  label: 'Citizens' },
      { to: '/for-agencies',  label: 'Law-enforcement agencies' },
      { to: '/for-partners',  label: 'Institutional partners' },
    ],
  },
  {
    title: 'Trust',
    links: [
      { to: '/security', label: 'Security & integrity' },
      { to: '/privacy',  label: 'Privacy' },
      { to: '/terms',    label: 'Terms of use' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/about',   label: 'About' },
      { to: '/contact', label: 'Contact' },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="container-wide py-14">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-md bg-slate-900 text-white">
                <Shield className="h-5 w-5" strokeWidth={2.4} />
              </div>
              <div className="text-sm font-bold tracking-wide text-slate-900">NACIS</div>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-6 text-slate-600">
              National AI Communications-Intelligence System — a federated trust fabric for
              civic reporting, identity integrity, and inter-agency coordination.
            </p>
          </div>

          {sections.map(section => (
            <div key={section.title}>
              <h4 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
                {section.title}
              </h4>
              <ul className="mt-4 space-y-2 text-sm">
                {section.links.map(l => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-slate-700 transition hover:text-slate-900">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-8 text-xs text-slate-500 md:flex-row md:items-center">
          <div>© {year} NACIS. Operated under federated inter-agency charter.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-slate-900">Privacy</Link>
            <Link to="/terms"   className="hover:text-slate-900">Terms</Link>
            <Link to="/security" className="hover:text-slate-900">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
